import { isTelephoneNumberValid } from '@/helpers/TelephoneHelpers';
import TelephoneService from '@/services/users/TelephoneService';

/**
 * Check if telephone is available
 *
 * @param {Number} telephone
 *
 * @returns {Boolean}
 */
export const isTelephoneUnique = (telephone) => {
    return (new TelephoneService()).legacyIsTelephoneAvailable(telephone);
};

/**
 * Check if telephone is valid telephone format.
 *
 * @param {Number} telephone
 *
 * @returns {Boolean}
 */
export const isValidTelephone = (telephone) => {
    return isTelephoneNumberValid(telephone);
};
